


























import { defineComponent } from "@vue/composition-api";
import { AbsBox, Icon } from "@ui";
import { Translate } from "@lang";
import { companyName, companyLogo, companyURL } from "@/info";

export default defineComponent({
	components:{
		Icon,
		AbsBox,
		Translate,
	},
	setup(){
		return {
			companyName,
			companyLogo,
			companyURL,
		}
	}
});

